/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_Proxy_RtInputs */

const en_media_import_source_proxy_rt = /** @type {(inputs: Media_Import_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy RT`)
};

const fr_media_import_source_proxy_rt = /** @type {(inputs: Media_Import_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy RT`)
};

const de_media_import_source_proxy_rt = /** @type {(inputs: Media_Import_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy RT`)
};

const it_media_import_source_proxy_rt = /** @type {(inputs: Media_Import_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy RT`)
};

const ru_media_import_source_proxy_rt = /** @type {(inputs: Media_Import_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прокси RT`)
};

const es_media_import_source_proxy_rt = /** @type {(inputs: Media_Import_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proxy RT`)
};

const zh_cn2_media_import_source_proxy_rt = /** @type {(inputs: Media_Import_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代理RT`)
};

const ja_media_import_source_proxy_rt = /** @type {(inputs: Media_Import_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロキシRT`)
};

const hi_media_import_source_proxy_rt = /** @type {(inputs: Media_Import_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रॉक्सी आरटी`)
};

const pt_pt2_media_import_source_proxy_rt = /** @type {(inputs: Media_Import_Source_Proxy_RtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RT por procuração`)
};

/**
* | output |
* | --- |
* | "Proxy RT" |
*
* @param {Media_Import_Source_Proxy_RtInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_proxy_rt = /** @type {((inputs?: Media_Import_Source_Proxy_RtInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_Proxy_RtInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_source_proxy_rt(inputs)
	if (locale === "de") return de_media_import_source_proxy_rt(inputs)
	if (locale === "it") return it_media_import_source_proxy_rt(inputs)
	if (locale === "ru") return ru_media_import_source_proxy_rt(inputs)
	if (locale === "es") return es_media_import_source_proxy_rt(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_source_proxy_rt(inputs)
	if (locale === "ja") return ja_media_import_source_proxy_rt(inputs)
	if (locale === "hi") return hi_media_import_source_proxy_rt(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_source_proxy_rt(inputs)
	return en_media_import_source_proxy_rt(inputs)
});